import React, { useContext } from "react";
import "./WhoWeAreSection2.css";

import bgImage from "../../../../imgs/about/whoBG.jpg"; // Replace with the background image path

import HandshakeTwoToneIcon from "@mui/icons-material/HandshakeTwoTone";
import WorkHistoryTwoToneIcon from "@mui/icons-material/WorkHistoryTwoTone";
import HomeWorkTwoToneIcon from "@mui/icons-material/HomeWorkTwoTone";
import ThumbUpAltTwoToneIcon from "@mui/icons-material/ThumbUpAltTwoTone";
import AccountBalanceWalletTwoToneIcon from "@mui/icons-material/AccountBalanceWalletTwoTone";
import TrendingUpTwoToneIcon from "@mui/icons-material/TrendingUpTwoTone";

import { Context } from "../../../LocalWrapper";

import { t } from "i18next";

const WhoWeAreSection2 = () => {
  const context = useContext(Context);

  return (
    <section
      className="who-we-are"
      style={{ backgroundImage: `url(${bgImage})` }}
      dir={context.dir}
    >
      <div className="w-overlay"></div>
      <div className="w-content">
        <h1 className="w-section-title oz-header">
          {t("about_profile_new_header")}
        </h1>
        <div className="w-columns">
          {/* Column 1 */}
          <div className="w-column">
            <div className="w-card tall-w-card">
              <HandshakeTwoToneIcon
                className="w-card-icon"
                sx={{ fontSize: "3rem" }}
              />
              <h3 className="w-card-title oz-subtitle">
                {t("about_profile_new_title1")}
              </h3>
              <p className="w-card-content oz-paragraph">
                {t("about_profile_new_p1")}
              </p>

              <p className="w-card-content oz-paragraph">
                {t("about_profile_new_p2")}
              </p>
            </div>
          </div>

          {/* Column 2 */}
          <div className="w-column">
            <div className="w-card">
              <HomeWorkTwoToneIcon
                className="w-card-icon"
                sx={{ fontSize: "3rem" }}
              />
              <h3 className="w-card-title oz-subtitle">
                {t("about_profile_new_title2")}
              </h3>
              <p className="w-card-content oz-paragraph">
                {t("about_profile_new_p3")}
              </p>
            </div>
            <div className="w-card">
              <WorkHistoryTwoToneIcon
                className="w-card-icon"
                sx={{ fontSize: "3rem" }}
              />
              <h3 className="w-card-title oz-subtitle">
                {t("about_profile_new_title3")}
              </h3>
              <p className="w-card-content oz-paragraph">
                {t("about_profile_new_p4")}
              </p>
            </div>
          </div>

          {/* Column 3 */}
          <div className="w-column">
            <div className="w-card">
              <AccountBalanceWalletTwoToneIcon
                className="w-card-icon"
                sx={{ fontSize: "3rem" }}
              />
              <h3 className="w-card-title oz-subtitle">
                {t("about_profile_new_title4")}
              </h3>
              <p className="w-card-content oz-paragraph">
                {t("about_profile_new_p5")}
              </p>
            </div>
            <div className="w-card">
              <TrendingUpTwoToneIcon
                className="w-card-icon"
                sx={{ fontSize: "3rem" }}
              />
              <h3 className="w-card-title oz-subtitle">
                {t("about_profile_new_title5")}
              </h3>
              <p className="w-card-content oz-paragraph">
                {t("about_profile_new_p6")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAreSection2;
